module.exports = __webpack_public_path__ + "static/media/bg-img.c7dff13d.svg";